import React, {useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Toolbar} from "@material-ui/core";
import ChromeTabs from "../../../controls/ChromeTabs";

import TripMessagingStyles from "../styles/TripMessagingStyles";
import TripMessagingList from "./TripMessagingList";
import TripCompanyMessagingList from "./TripCompanyMessagingList";

const TripMessaging = (props) => {
  const classes = makeStyles(TripMessagingStyles)();

  const listVariant = props.listVariant;

  const [state, setState] = useState({
    canEdit: props.canEdit,
    tripUuid: props.tripUuid,
    tripLegUuid: props.tripLegUuid,
    tripRoute: props.route
  });

  const [messagingTabs, setMessagingTabs] = useState(
    [
      {label: "Company", value: "company"},
      {label: "Ad-Hoc", value: "adhoc"},
    ]
  );
  const [currentTab, setCurrentTab] = useState("company");

  const handleTabChange = (e, i) => {
    setCurrentTab(i);
  }

  const marginLeft = listVariant === "TRIP" ? 0 : 50;
  const marginRight = listVariant === "TRIP" ? 0 : 50;

  return (
    <div style={{ marginLeft: marginLeft, marginRight: marginRight }}>
      <Toolbar variant={"dense"}>
        <ChromeTabs
          id={"TripMessaging"}
          //style={{ alignSelf: "flex-end", display: "inline-block", align: "left" }}
          style={{ marginTop: 10 }}
          tabs={messagingTabs}
          tabStyle={{
            bgColor: "#E6E8EB",
            selectedBgColor: "#ffffff",
            color: "rgba(0,0,0,0.87)",
          }}
          tabProps={{
            disableRipple: false,
          }}
          value={currentTab}
          onChange={handleTabChange}
        />
      </Toolbar>
      <div style={{width: "100%"}}>
        {currentTab === "company"
          ?
            <div>
              <TripCompanyMessagingList
                canEdit={state.canEdit}
                listVariant={listVariant}
                tripUuid={state.tripUuid}
                tripLegUuid={state.tripLegUuid}
                route={state.tripRoute}
              />
            </div>
          :
            <div>
              <TripMessagingList
                canEdit={state.canEdit}
                listVariant={listVariant}
                tripUuid={state.tripUuid}
                tripLegUuid={state.tripLegUuid}
                route={state.tripRoute}
              />
            </div>
        }
      </div>
      {/*<div style={{ marginTop: -10 }}/>*/}
      {/*<Toolbar variant={"dense"}>*/}
      {/*  <ChromeTabs*/}
      {/*    id={"TripMessaging"}*/}
      {/*    //style={{ alignSelf: "flex-end", display: "inline-block", align: "left" }}*/}
      {/*    style={{ marginTop: 10 }}*/}
      {/*    tabs={messagingTabs}*/}
      {/*    tabStyle={{*/}
      {/*      bgColor: "#E6E8EB",*/}
      {/*      selectedBgColor: "#ffffff",*/}
      {/*      color: "rgba(0,0,0,0.87)",*/}
      {/*      borderTopLeftRadius: 0,*/}
      {/*      borderTopRightRadius: 0,*/}
      {/*      borderBottomLeftRadius: 1,*/}
      {/*      borderBottomRightRadius: 1,*/}
      {/*    }}*/}
      {/*    tabProps={{*/}
      {/*      disableRipple: false,*/}
      {/*    }}*/}
      {/*    value={currentTab}*/}
      {/*    onChange={handleTabChange}*/}
      {/*  />*/}
      {/*</Toolbar>*/}
      {/*<div style={{ height: 10 }}/>*/}
    </div>
  );
}

export default TripMessaging;